/**
 * Phasenaufgaben (Plan Projekt-Tracking, Etappe 4, `kontor_phasenaufgaben.py`):
 * die fertige Mail zur Aufgabe und der Rückweg nach dem Versand; dazu seit
 * 11.10.2026 „Zahlungseingang prüfen" bestätigen (`POST …/zuordnen`).
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost } from "@vimaana/ui";

export type PhasenMailEntwurf = {
  regel: "nachhaken" | "zahlungserinnerung";
  nummer: string;
  projekt_id: string;
  an: string;
  titel: string;
  betreff: string;
  text: string;
};

export function usePhasenaufgabeEntwurf(notizId: string) {
  return useQuery<PhasenMailEntwurf>({
    queryKey: ["phasenaufgabe", notizId, "entwurf"],
    queryFn: () => apiGet<PhasenMailEntwurf>(`/api/kontor/phasenaufgabe/${notizId}/entwurf`),
    staleTime: 60_000,
  });
}

/** Nach dem Versand: Vorgang in die Spur des Belegs, Aufgabe abgehakt. */
export function usePhasenaufgabeGesendet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { notizId: string; an: string[] }) =>
      apiPost<{ ok: boolean }>(`/api/kontor/phasenaufgabe/${v.notizId}/gesendet`, { an: v.an }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notizen"] });
      qc.invalidateQueries({ queryKey: ["projekt"] });
      qc.invalidateQueries({ queryKey: ["projekte"] });
      qc.invalidateQueries({ queryKey: ["invoices"] });
    },
  });
}

/** „Zahlungseingang prüfen": Vorschlag bestätigen — Zahlung wird zugeordnet, Aufgabe abgehakt. */
export function usePhasenaufgabeZuordnen() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (notizId: string) =>
      apiPost<{ ok: boolean; nummer: string; bezahlt: boolean }>(`/api/kontor/phasenaufgabe/${notizId}/zuordnen`, {}),
    onSuccess: () => {
      for (const key of ["notizen", "projekt", "projekte", "invoices", "konto"]) {
        qc.invalidateQueries({ queryKey: [key] });
      }
    },
  });
}
